<template>
	<div class="person" style="width: 100%;min-height: 850px;background-color: white;">
		<a @click="userRegister=true" style="padding: 16px;">注册使用指南</a>
		<span>未进入科室？<a style="color: red;" @click="$router.push({path:'/core/entryMsg'})">申请入室</a></span>
		<a-form-model @submit.native.prevent :rules="rules" ref="ruleForm" style="width: 75rem;margin: 0 auto;"
			layout="inline" :model="form">
			<a-row>
				<a-col style="margin-top: 20px;" :span="10" :offset="2">
					<p style="color: #4B4B4B;font-size: 1rem;font-weight: 500;">
						<span style="color: #F64C4C;font-size: 13px;font-weight: 500;">*</span>
						账户名称
					</p>
					<a-form-model-item label="" prop="username">
						<a-input :disabled="!isDisabled" style="width: 280px;height:2.3rem;" v-model="form.username"
							placeholder="3~12位数字或英文，建议使用工号或手机号" />

					</a-form-model-item>
				</a-col>

				<a-col style="margin-top: 20px;" :span="10" :offset="2">
					<p style="color: #4B4B4B;font-size: 1rem;font-weight: 500;">
						<span style="color: #F64C4C;font-size: 13px;font-weight: 500;">*</span>
						E-mail
					</p>
					<a-form-model-item label="" prop="email">
						<a-input style="width: 280px;height:2.3rem;" v-model="form.email" placeholder="请输入电子邮箱地址" />
					</a-form-model-item>
				</a-col>
				<a-col style="margin-top: 20px;" :span="10" :offset="2" v-if="!isPwd">
					<p style="color: #4B4B4B;font-size: 1rem;font-weight: 500;">
						密码
					</p>
					<a-form-model-item label="" prop="password">
						<a-input type="Password" style="width: 280px;height:2.3rem;" v-model="form.password"
							placeholder="8-16位,包含数字大、小写字母" />
					</a-form-model-item>
					<div v-if="this.passCore>1" style="color: green;position: absolute;">
						当前密码强度为{{this.passCore==2?'一般':this.passCore==3?'正常':this.passCore==4?'良好':''}},可以使用</div>
				</a-col>
				<a-col style="margin-top: 20px;" :span="10" :offset="2" v-if="!isPwd">
					<p style="color: #4B4B4B;font-size: 1rem;font-weight: 500;">
						<span style="color: #F64C4C;font-size: 13px;font-weight: 500;">*</span>
						确认密码
					</p>
					<a-form-model-item label="" prop="password2">
						<a-input type="Password" style="width: 280px;height:2.3rem;" v-model="form.password2"
							placeholder="8-16位,包含数字大、小写字母" />
					</a-form-model-item>
					<div v-if="this.passCore2>1" style="color: green;position: absolute;">
						当前密码强度为{{this.passCore2==2?'一般':this.passCore2==3?'正常':this.passCore2==4?'良好':''}},可以使用</div>
				</a-col>
				<a-col style="margin-top: 20px;" :span="10" :offset="2">
					<p style="color: #4B4B4B;font-size: 1rem;font-weight: 500;">
						<span style="color: #F64C4C;font-size: 13px;font-weight: 500;">*</span>
						姓名
					</p>
					<a-form-model-item label="" prop="name">
						<a-input style="width: 280px;height:2.3rem;" v-model="form.name" placeholder="您的真实姓名" />
					</a-form-model-item>
				</a-col>
				<a-col style="margin-top: 20px;" :span="10" :offset="2">
					<p style="color: #4B4B4B;font-size: 1rem;font-weight: 500;">
						<span style="color: #F64C4C;font-size: 13px;font-weight: 500;">*</span>
						身份
					</p>
					<a-form-model-item label="" prop="identity">
						<a-select show-search placeholder="输入姓名后查找，支持首字母搜索" v-model="form.identity"
							option-filter-prop="children" style="width: 280px;height:2.3rem;">
							<a-select-option :value="13">
								学生
							</a-select-option>
							<a-select-option :value="0">
								本科生
							</a-select-option>
							<a-select-option :value="1">
								硕士研究生
							</a-select-option>
							<a-select-option :value="2">
								博士研究生
							</a-select-option>
							<a-select-option :value="7">
								博士后
							</a-select-option>
							<a-select-option :value="3">
								导师/负责人
							</a-select-option>
							<a-select-option :value="4">
								在编人员
							</a-select-option>
							<a-select-option :value="5">
								工作人员/合同人员
							</a-select-option>
						</a-select>
					</a-form-model-item>
				</a-col>
				<a-col style="margin-top: 20px;" :span="10" :offset="2">
					<p style="color: #4B4B4B;font-size: 1rem;font-weight: 500;">

						年级</p>
					<a-form-model-item label="">
						<a-input style="width: 280px;height:2.3rem;" v-model="form.grade">

						</a-input>
					</a-form-model-item>
				</a-col>
				<!-- <a-col style="margin-top: 20px;" :span="10" :offset="2">
					<p style="color: #4B4B4B;font-size: 1rem;font-weight: 500;">

						导师/负责人<span style="font-size: 12px;color: gray;">(请输入姓名或拼音首字母搜索)</span></p>
					<a-form-model-item label=""  >
						
						<a-select
						    show-search
						   label-of-value
						    @select="selectName"
						    v-model="form.tutor"
							 option-filter-prop="children"
							placeholder="请输入搜索条件支持拼音/中文"
						   style="width: 280px;height:2.3rem;"
						    :filter-option="false"
						    :not-found-content="fetching ? undefined : null"
						    @search="fetchUser"
						    @change="handleChange"
						  >
						    <a-spin v-if="fetching" slot="notFoundContent" size="small" />
						    <a-select-option v-for="d in data" :key="d.userId">
						      {{ d.realName }}--{{d.unit}}
						    </a-select-option>
						  </a-select>
					</a-form-model-item>
				</a-col> -->
				<a-col style="margin-top: 20px;" :span="10" :offset="2">
					<p style="color: #4B4B4B;font-size: 1rem;font-weight: 500;">
						<span style="color: #F64C4C;font-size: 13px;font-weight: 500;">*</span>
						导师/负责人
					</p>
					<a-form-model-item label="" prop="tutor2">

						<a-input v-model="form.tutor2" placeholder="请输入导师/负责人" style="width: 280px;">

						</a-input>
					</a-form-model-item>
				</a-col>

				<a-col style="margin-top: 20px;" :span="10" :offset="2">
					<p style="color: #4B4B4B;font-size: 1rem;font-weight: 500;">
						<span style="color: #F64C4C;font-size: 13px;font-weight: 500;">*</span>
						单位
					</p>
					<a-form-model-item label="" prop="company">
						<a-select @change="changeCompany" style="width: 280px;" v-model="form.company">
							<a-select-option :value="item.unitId" v-for="(item,index) in companyData">
								{{item.unitName}}
							</a-select-option>

						</a-select>
					</a-form-model-item>
				</a-col>
				<a-col style="margin-top: 20px;" :span="10" :offset="2">
					<p style="color: #4B4B4B;font-size: 1rem;font-weight: 500;">
						<span style="color: #F64C4C;font-size: 13px;font-weight: 500;">*</span>
						申请实验室
					</p>
					<a-form-model-item label="" prop="depart">
						<a-select style="width: 280px;height:2.3rem;" v-model="form.depart">
							<a-select-option :value="item.unitId" v-for="(item,index) in departData">
								{{item.unitName}}
							</a-select-option>
						</a-select>
					</a-form-model-item>
				</a-col>
				<!-- <a-col style="margin-top: 20px;" :span="10" :offset="2">
					<p style="color: #4B4B4B;font-size: 1rem;font-weight: 500;">

						主卡号</p>
					<a-form-model-item label="">
						<a-input  style="width: 280px;height:2.3rem;" v-model="form.masterNum" />
					</a-form-model-item>
				</a-col> -->

				<!-- <a-col style="margin-top: 20px;" :span="10" :offset="2">
					<p style="color: #4B4B4B;font-size: 1rem;font-weight: 500;">

						副卡号</p>
					<a-form-model-item label="">
						<a-input  style="width: 280px;height:2.3rem;" v-model="form.developNum" />
					</a-form-model-item>
				</a-col> -->
				<a-col style="margin-top: 20px;" :span="10" :offset="2">
					<p style="color: #4B4B4B;font-size: 1rem;font-weight: 500;">

						性别</p>
					<a-form-model-item label="" prop="sex">
						<a-radio-group v-model="form.sex">
							<a-radio :value="1">
								男
							</a-radio>
							<a-radio :value="2">
								女
							</a-radio>
						</a-radio-group>
					</a-form-model-item>
				</a-col>
				<a-col style="margin-top: 0px;" :span="10" :offset="2">

					<a-form-model-item label="" prop="tutor3">
						<div style="margin-top: 20px;color: #4B4B4B;font-size: 1rem;font-weight: 500;">
							<span style="color: #F64C4C;font-size: 13px;font-weight: 500;margin-bottom: 20px;">*</span>
							课题组所在科室
						</div>
						<a-input v-model="form.tutor3" placeholder="请输入课题组所在科室" style="width: 280px;">

						</a-input>
					</a-form-model-item>
				</a-col>
				<a-col style="margin-top: 40px;" :span="10" :offset="2">
				<a-form-model-item label="" >
					<div class="checkMan">
						<h2>上传电子签名</h2>
						<a-button @click="dialogVisible = true" type="primary">点击签字</a-button>
						<!-- 用户用来预览签字图片的地方 -->
						<img v-if="resultImg" :src="resultImg" alt="" />
					</div>
				</a-form-model-item>
				</a-col>
				<a-col style="margin-top: 40px;" :span="10" :offset="2">

					<a-form-model-item label="" prop="code">
						<div style="display: flex;align-items: center;height: 40px;">
							<a-input class="boxYz" v-model="form.code" type="UserName" placeholder="请输入图形验证码">
								<a-icon slot="prefix" type="code" style="color:rgba(0,0,0,.25)" />
							</a-input>
							<img @click="changeCode" style="width: 70px;height: 29px;cursor: pointer;margin-left: 8px;"
								:src="codeUrl">
						</div>
					</a-form-model-item>
					<!-- <a-form-model-item label="" prop="smsCode">
						<div style="display: flex;position: relative;">
							<a-input style="width: 280px;height:2.3rem;" v-model="form.smsCode" 
								placeholder="请输入短信验证码" />
							<a-button :disabled="disabled" @click="sendcode"
								style="width: 4rem;height: 2rem;background-color: red;position: absolute; background: #1890FF;
							border-radius: 4px;font-size: 14px;display: flex;justify-content: center;align-items: center;color: #FFFFFF;right: 2px;top: 2px;">
								{{btntxt}}
							</a-button>
						</div>
						<a-modal class="modals" width="300px" style="" v-model="modalVisible2" @ok="handleOk2">
							<p style="color: #4B4B4B;font-size: 18px;">获取短信验证码</p>
							<div style="display: flex;align-items: center;height: auto">
								<a-input disabled class="boxYz" v-model="form.phone" type="UserName" placeholder="请输入手机号">
									<a-icon slot="prefix" type="phone" style="color:rgba(0,0,0,.25)" />
								</a-input>
							</div>
						</a-modal>
						<a-modal class="modals" width="380px" style="" v-model="modalVisible" @ok="handleOk">
							<p style="color: #4B4B4B;font-size: 18px;">网络安全验证</p>
							<div style="display: flex;align-items: center;height: 120px;">
								<img @click="changeCode"
									style="width: 70px;height: 29px;cursor: pointer;margin-right: 8px;" :src="codeUrl">
								<a-input class="boxYz" v-model="form.code" type="UserName" placeholder="请输入图形验证码">
									<a-icon slot="prefix" type="code" style="color:rgba(0,0,0,.25)" />
								</a-input>
							</div>
						</a-modal>
					</a-form-model-item> -->
				</a-col>
				
				
				<a-col style="margin-top: 20px;" :span="10" :offset="8">
					<a-button @click="onSubmit" style="width: 220px;height: 50px;margin-top: 40px;" type="primary">
						确定
					</a-button>
				</a-col>
			</a-row>

		</a-form-model>
		<a-modal okText="我已知晓" title="注册使用指南" :visible="userRegister" :confirm-loading="confirmLoading"
			@ok="userRegister=false" @cancel="userRegister=false">
			<div>
				<p style="font-size: 20px;color: black;">您已完成账号注册，要使用还需完成以下内容</p>
				<p>1.完成个人资料填写，并保存</p>
				<p>2.申请入室，并通过入室申请</p>
			</div>
		</a-modal>

		<div id="app">
			<!-- 做使用el-dialog做签字的弹框 -->
			<a-modal title="签字" :visible.sync="dialogVisible" width="800px" append-to-body>
				<!-- 使用这个签名组件 -->
				<vue-esign ref="esign" class="mySign" :width="800" :height="300" :isCrop="isCrop" :lineWidth="lineWidth"
					:lineColor="lineColor" :bgColor.sync="bgColor" />
				<span slot="footer" class="dialog-footer">
					<a-button @click="handleGenerate" type="primary">生成签字图片</a-button>
					<a-button @click="handleReset">清空画板</a-button>
					<a-button @click="dialogVisible = false">取消</a-button>
				</span>
			</a-modal>
			<!-- 审查人点击确认签字按钮触发签字 -->
			
		</div>

	</div>
</template>

<script>
	import {
		mapState
	} from "vuex";
	import debounce from 'lodash/debounce';
	import {
		SelPersonalData,
		SecurityCode,
		SendValidateCode,
		SetPersonalData,
		SelUserList,
		Fileimg
	} from '@/api/index.js'
	import axios from 'axios'
	import Qs from 'qs'
	export default {
		name: '/core/personalData',
		computed: {
			...mapState(['userData', 'userList'])
		},
		data() {
			var validatePassword = (rule, value, callback) => {
				console.log(rule)
				const num = /^.*[0-9]+.*/
				const low = /^.*[a-z]+.*/
				const up = /^.*[A-Z]+.*/
				const spe = /^.*[^a-zA-Z0-9]+.*/
				const passLength = value.length >= 8 && value.length <= 16
				let core = 0
				//num.test(value) && low.test(value) && up.test(value)
				if (passLength) {
					if (num.test(value)) {
						console.log("数字")
						core += 1
					}
					if (low.test(value)) {
						console.log("小写字母")
						core += 1
					}
					if (up.test(value)) {
						console.log("大写字母")
						core += 1
					}
					if (spe.test(value)) {
						console.log("字符")
						core += 1
					}
					if (core <= 1) {
						setTimeout(() => {
							this.passCore = core
						}, 200)

						callback('存在风险，至少使用大小写字母、数字、符号中2种')
					} else {
						setTimeout(() => {
							this.passCore = core
						}, 200)
						callback()
					}

				} else {
					setTimeout(() => {
						this.passCore = 0
					}, 200)
					callback(new Error('密码长度错误，密码长度为8-16位'));
				}

			}
			var validatePassword2 = (rule, value, callback) => {
				console.log(rule)
				const num = /^.*[0-9]+.*/
				const low = /^.*[a-z]+.*/
				const up = /^.*[A-Z]+.*/
				const spe = /^.*[^a-zA-Z0-9]+.*/
				const passLength = value.length >= 8 && value.length <= 16
				let core = 0
				//num.test(value) && low.test(value) && up.test(value)
				if (passLength) {
					if (num.test(value)) {
						console.log("数字")
						core += 1
					}
					if (low.test(value)) {
						console.log("小写字母")
						core += 1
					}
					if (up.test(value)) {
						console.log("大写字母")
						core += 1
					}
					if (spe.test(value)) {
						console.log("字符")
						core += 1
					}
					if (core <= 1) {
						setTimeout(() => {
							this.passCore2 = core
						}, 200)

						callback('存在风险，至少使用大小写字母、数字、符号中2种')
					} else {
						setTimeout(() => {
							this.passCore2 = core
						}, 200)
						callback()
					}

				} else {
					setTimeout(() => {
						this.passCore2 = 0
					}, 200)
					callback(new Error('密码长度错误，密码长度为8-16位'));
				}

			}
			return {
				dialogVisible: false, // 弹框是否开启
				lineWidth: 6, // 画笔的线条粗细
				lineColor: "#000000", // 画笔的颜色
				bgColor: "", // 画布的背景颜色
				resultImg: "", // 最终画布生成的base64图片
				isCrop: false, // 是否裁剪，在画布设定尺寸基础上裁掉四周空白部分

/* 以上画布参数 */
				userRegister: false,
				passCore: 0,
				passCore2: 0,
				isPwd: true,
				isDisabled: true,
				data: [],
				value: [],
				fetching: false,
				btntxt: '发送',
				codeUrl: '',
				modalVisible: false,
				modalVisible2: false,
				disabled: false,
				userLists: [],
				form: {
					username: '',
					email: '',
					password: '',
					password2: '',
					name: '',
					identity: '',
					grade: '',
					tutor: 0,
					tutor2: '',
					tutor3: '',
					company: '',
					depart: '',
					masterNum: '',
					developNum: '',
					sex: 0,
					code: '',
					smsCode: '',
					codeid: '',
					phone: '',

				},

				rules: {
					password: [{
						required: true,
						validator: validatePassword,
						trigger: 'change'
					}],
					password2: [{
						required: true,
						validator: validatePassword2,
						trigger: 'change'
					}],
					code: [{
							required: true,
							message: '验证码不能为空',
							trigger: 'blur'
						},
						{
							min: 4,
							max: 4,
							message: '验证码长度错误',
							trigger: 'blur'
						}
					],
					smsCode: [{
							required: true,
							message: '图形验证码不能为空',
							trigger: 'blur'
						},
						{
							min: 6,
							max: 6,
							message: '短信验证码长度错误',
							trigger: 'blur'
						}
					],
					phone: [{
							required: true,
							message: '手机号不能为空',
							trigger: 'blur'
						},
						{
							min: 11,
							max: 11,
							message: '手机号长度错误,请输入11位手机号',
							trigger: 'blur'
						}
					],
					username: [{
						required: true,
						message: '用户名不能为空',
						trigger: 'blur'
					}],
					email: [{
							required: true,
							message: '请填写邮箱',
							trigger: 'blur'
						},
						{
							type: 'string',
							message: '邮箱格式不正确',
							trigger: 'blur',
							transform(value) {
								if (!/^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/.test(
										value)) {
									return true
								} else {}
							}
						},
						{
							type: 'string',
							message: '长度不能超过30位',
							trigger: 'blur',
							max: 30
						}
					],
					name: [{
						required: true,
						message: '姓名不能为空',
						trigger: 'blur'
					}],
					identity: [{
						required: true,
						message: '身份不能为空',
						trigger: 'blur'
					}],
					grade: [{
						required: true,
						message: '年级不能为空',
						trigger: 'blur'
					}],
					tutor2: [{
						required: true,
						message: '导师/负责人不能为空',
						trigger: 'blur'
					}],
					tutor3: [{
						required: true,
						message: '课题组所在科室不能为空',
						trigger: 'blur'
					}],
					company: [{
						required: true,
						message: '单位不能为空',
						trigger: 'blur'
					}],
					depart: [{
						required: true,
						message: '科室不能为空',
						trigger: 'blur'
					}],
					sex: [{
						required: true,
						message: '性别不能为空',
						trigger: 'blur'
					}],


				},

				companyData: [],
				departData: [],
				source: []
			};
		},

		created() {
			if (window.localStorage.getItem('userRegister')) {
				this.userRegister = true
				window.localStorage.removeItem('userRegister')
			}
			this.lastFetchId = 0
			this.fetchUser = debounce(this.fetchUser, 800)
			let code = Math.random()
			this.form.codeid = code + ''
			this.getSecurityCode(code)
			this.getSelPersonalData('first')
			axios.post('/Flat/SelUserList', Qs.stringify({
					name: value
				}))
				.then((res) => {
					this.fetching = false
					this.data = res.data.data
					this.$store.commit('updateUserData', res.data.data)
					// window.localStorage.setItem('userData',JSON.stringify(this.data))
					console.log(this.data)
				})

		},
		methods: {
				base64ToFile(base64Data, filename) {
				// 将base64的数据部分提取出来
			    const parts = base64Data.split(';base64,');
			    const contentType = parts[0].split(':')[1];
			    const raw = window.atob(parts[1]);
			    
			    // 将原始数据转换为Uint8Array
			    const rawLength = raw.length;
			    const uInt8Array = new Uint8Array(rawLength);
			    for (let i = 0; i < rawLength; ++i) {
			        uInt8Array[i] = raw.charCodeAt(i);
			    }
			    
			    // 使用Blob和提取出的数据内容创建一个新的Blob对象
			    const blob = new Blob([uInt8Array], {type: contentType});
			    
			    // 创建一个指向Blob对象的URL，并使用这个URL创建一个File对象
			    const blobUrl = URL.createObjectURL(blob);
			    const file = new File([blob], filename, {type: contentType});
			    
			    // 返回File对象
			    return file;
			},
			handleReset() {
				this.$refs.esign.reset();
			},
			// 生成签字图
			handleGenerate() {
				let that = this
				this.$refs.esign
					.generate() // 使用生成器调用把签字的图片转换成为base64图片格式
					.then((res) => {
						this.resultImg = res;
						
						let file = this.base64ToFile(res, '签名')
						const formData = new FormData();
						// 将文件添加到FormData对象中
						formData.append('input', new Blob([file],{type:"image/jpeg"}),"image.png");
						Fileimg(formData).then((ress)=>{
							
							this.resultImg = ress.data.data.ip+ress.data.data.data[0].path
							console.log(ress.data.data.data[0].path)
							
						})
					})
					.catch((err) => {
						// 画布没有签字时会执行这里提示一下
						this.$message.error('请签名后再生成签字图片')
					});

				// 在这里向后端发请求把转换后的base64文件传给后端，后端接收以后再转换成图片做静态图片存储
				// 当然也可以把base64转成流文件blob格式的，类似上传给后端这样，具体哪种方式看后端要求
				setTimeout(() => {
					// 这里要使用定时器稍微延后以后就能取到base64数据了，当然也可以再加一个确认按钮，如：确认使用这张base64签名图片
					// 点击确认以后，在其回调函数中，再把base64的签名图片传给后端用于存储
					console.log('我是签字后的base64图片', this.resultImg);
				}, 200);
				this.dialogVisible = false;
			},


			async getSelPersonalData() {
				const res = await SelPersonalData()
				const res2 = await SelUserList()
				this.$store.commit('updateUserList', res2.data.data)
				console.log(res)
				console.log("断电")
				this.source = res.data.data
				this.userLists = this.userList
				let selectedMsg = {}
				this.userLists.map((n) => {
					if (n.userId == this.source.tutorId) {
						selectedMsg = n
					}
				})
				this.data = [selectedMsg]
				console.log("断电111")
				console.log(this.data)
				if (this.source.realName == '') {
					window.localStorage.setItem('newUser', true)
				}
				this.form.username = this.source.userName ? this.source.userName : ''
				this.isDisabled = this.source.userName == '' ? true : false
				this.form.email = this.source.email ? this.source.email : ''
				this.form.name = this.source.realName ? this.source.realName : ''
				this.form.identity = this.source.identity ? this.source.identity : ''
				this.form.grade = this.source.grades ? this.source.grades : ''
				this.form.tutor = this.source.tutorId ? this.source.tutorId : ''
				this.form.tutor2 = this.source.tutor
				this.form.tutor3 = this.source.rugUnit
				this.form.company = this.source.unitId ? this.source.unitId : ''
				this.form.sex = this.source.gender
				this.form.masterNum = this.source.mainCard ? this.source.mainCard : ''
				this.form.developNum = this.source.viceCard ? this.source.viceCard : ''
				this.isPwd = this.source.isPwd
				
				this.resultImg = this.source.realNameImg
				console.log(this.source.realNameImg)
				this.source.units.map((n) => {
					if (n.unitPid == 0) {
						this.companyData.push(n)
					}
				})
				console.log(this.form.tutor)
				this.source.units.map((n) => {
					// console.log(n)
					if (this.source.unitId == n.unitPid) {
						this.departData.push(n)
					}
				})
				console.log(this.departData)

				this.form.depart = this.source.departmentId ? this.source.departmentId : ''

			},
			onSubmit() {
				var that = this
				this.$refs.ruleForm.validate(valid => {
					if (valid) {
						if (this.form.password != this.form.password2) {
							that.$message.error("密码与确认密码不一致")
							return
						}
						if (this.form.masterNum != '' && this.form.developNum != '') {
							if (this.form.masterNum == this.form.developNum) {
								that.$message.error("主卡号与副卡号相同")
								return
							}
						}

						console.log(this.form.username)
						let FORM = {
							cellPhone: this.form.phone ? this.form.phone : '',
							code: this.form.code ? this.form.code : '',
							codeid: this.form.codeid,
							UserName: this.form.username ? this.form.username : '',
							Email: this.form.email ? this.form.email : '',
							RealName: this.form.name ? this.form.name : '',
							Identity: this.form.identity ? this.form.identity : '',
							// TutorId:this.form.tutor?this.form.tutor:0,
							TutorId: 0,
							Tutor: this.form.tutor2,
							RugUnit: this.form.tutor3,
							UnitId: this.form.company ? this.form.company : 0,
							DepartmentId: this.form.depart ? this.form.depart : 0,
							MainCard: this.form.masterNum ? this.form.masterNum : '',
							ViceCard: this.form.developNum ? this.form.developNum : '',
							Gender: this.form.sex ? this.form.sex : '',
							pwd1: this.form.password ? this.form.password : '',
							pwd2: this.form.password2 ? this.form.password2 : '',
							Grades: this.form.grade ? this.form.grade : '',
							realNameImg:this.resultImg
						}
						console.log(FORM)

						SetPersonalData(FORM).then((res) => {
							console.log(res)
							if (res.data.state) {
								this.getSelPersonalData()
								this.$message.success('修改个人资料成功')
								console.log(this.$parent)
								SelPersonalData().then((res) => {

									this.$store.commit("updateUserMsg", res.data.data)
									this.$parent.$parent.$children[0].reloadToken()
									this.$parent.$children[0].reloadToken()
									let code = Math.random()
									this.form.codeid = code + ''
									this.form.code = ''
									this.getSecurityCode(code)
									console.log(this.$parent)
									console.log(res.data.data)
									if (window.localStorage.getItem('newUser')) {
										that.$confirm({
											title: '正式使用前，须先申请入室。点击确认，马上申请入室',
											// content: h => <div style="color:red;">Some descriptions</div>,
											onOk() {
												window.localStorage.removeItem('newUser')
												that.$router.push({
													path: '/core/entryMsg'
												})
											},
											onCancel() {
												location.reload()
											},
											class: 'test',
										});
									} else {
										location.reload()
									}


									console.log("断电")
								})


							} else {
								let code = Math.random()
								this.form.codeid = code + ''
								this.form.code = ''
								this.getSecurityCode(code)
								this.$message.error(res.data.info)
							}
						})

					} else {

						console.log('error submit!!');

						return false;
					}
				});
			},
			changeCompany(val) {
				this.form.depart = ''
				this.departData = []
				this.source.units.map((n) => {
					if (n.unitPid == val) {
						this.departData.push(n)
					}
				})
				console.log(this.departData)
			},
			sendcode() {
				this.form.phone = this.userMsg.tol
				this.modalVisible2 = true


			},
			async getSecurityCode(data) {
				const res = await SecurityCode(data)
				console.log(res)
				this.codeUrl = res.request.responseURL
			},
			Cancel() {

				this.form.code = ''
				this.modalVisible = false
			},
			handleOk2() {
				if (this.form.phone == '' || this.form.phone == undefined) {
					this.$message.error('手机号不能为空')
					return
				} else if (this.form.phone.length != 11) {
					this.$message.error('手机号长度错误')
					return
				}
				this.modalVisible2 = false
				this.handleOk()
				// this.modalVisible = true
				// let code = Math.random()
				// this.form.codeid = code + ''
				// this.getSecurityCode(code)
			},
			changeCode() {
				let code = Math.random()
				this.form.codeid = code + ''
				this.getSecurityCode(code)
			},
			selectName(data, item) {
				console.log(data)
				let userData = this.userData
				let selectedMsg = {}
				userData.map((n) => {
					if (n.userId == data) {
						selectedMsg = n
					}
				})
				this.data = [selectedMsg]
				this.form.tutor = data
			},
			timer() {
				if (this.time > 0) {
					this.disabled = true;
					this.time--;
					this.btntxt = this.time + "秒再发";
					setTimeout(this.timer, 1000);
				} else {
					this.time = 0;
					this.btntxt = "发送";
					this.disabled = false;
				}
			},
			async handleOk() {
				const res = await SendValidateCode({
					cellPhone: this.form.phone,
					smsValidateType: 2,
					Code: this.form.code,
					CodeId: this.form.codeid
				})
				console.log(res)
				if (res.data.state) {
					this.modalVisible = false
					this.form.code = ''
					this.time = 60;
					this.timer();
				} else {
					this.$message.error(res.data.info);
					let code = Math.random()
					this.form.codeid = code + ''
					this.getSecurityCode(code)
				}

			},
			fetchUser(value) {
				if (value == '') {
					return
				}

				if (value.indexOf(" ") != -1) {
					this.$message.error("搜索条件不能包含空字符")
					return
				}
				console.log('fetching user', value);
				this.lastFetchId += 1;
				const fetchId = this.lastFetchId;
				this.data = [];
				this.fetching = true;
				axios.post('/Flat/SelUserList', Qs.stringify({
						name: value
					}))
					.then((res) => {
						this.fetching = false
						this.data = res.data.data
						this.$store.commit('updateUserData', this.data)
						console.log(this.data)
					})

			},
			handleChange(value) {
				Object.assign(this, {
					value,
					data: [],
					fetching: false,
				});
			},
		},
	};
</script>
<style>
	.person .ant-form-explain {
		position: absolute !important;
	}

	.person .ant-form-item-with-help {
		margin-bottom: 0 !important;
	}
</style>

<style lang="less" scoped>
	#app {
		width: 100%;
		height: 100%;
		padding: 60px;

		.checkMan {
			width: 400px;
			height: 360px;
			text-align: center;
			border: 1px solid #e9e9e9;
			padding-top: 40px;

			h2 {
				margin-bottom: 20px;
			}

			.el-button {
				margin-bottom: 20px;
			}

			img {
				width: 100%;
				height: 200px;
			}
		}
	}

	/deep/ .el-dialog__body {
		// 设置一下签字区域的虚线边框
		.mySign {
			border: 1px dashed #000;
		}
	}
</style>